export default "__VITE_ASSET__CuZdFfRU__"